import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  MelcoModelsUser,
  UseApiQueryKey,
  useFormSubmit,
} from "melco-shared-logic";
import { Formik, FormikHelpers } from "formik";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplayEditUserForm } from "../form/DisplayEditUserProfileForm";
import { useQueryClient } from "react-query";
import { useUpdateUserProfile } from "../../../hooks/users/useUpdateUserProfile";

type UserDetailProfileDrawerProps = {
  user: MelcoModelsUser;
  isEditProfileDrawerOpen: boolean;
  closeAllDrawerAction: () => void;
  queryKey: UseApiQueryKey;
};

export const UserDetailEditProfileDrawer: React.FC<
  UserDetailProfileDrawerProps
> = ({ queryKey, closeAllDrawerAction, isEditProfileDrawerOpen, user }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  //const queryKey = "editprofle";
  const updateUserProfile = useUpdateUserProfile();

  const initialValues: MelcoModelsUser = user;

  const generateUserProfileToInitialValues = (formvalues: MelcoModelsUser) => {
    const { first_name, last_name } = formvalues;

    const initialValues: MelcoModelsUser = {
      first_name: first_name ?? "",
      last_name: last_name ?? "",
    };

    return initialValues;
  };

  const onSubmit = async (
    values: MelcoModelsUser,
    formikHelpers: FormikHelpers<MelcoModelsUser>
  ) => {
    await onEditUserProfile(values, formikHelpers, {});
  };

  const formSubmitToEditUserProfile = () => {
    return [
      async (
        values: MelcoModelsUser,
        formikHelpers: FormikHelpers<MelcoModelsUser>
      ) => {
        return handleEditProfile(values, formikHelpers, {});
      },
      {
        translationOptions: {
          batchNumber: 1,
        },
        translationPrefix: ["users.actions", "update"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const handleEditProfile = async (
    values: MelcoModelsUser,
    formikHelpers: FormikHelpers<MelcoModelsUser>,
    options: {}
  ) => {
    const newEntity = await updateUserProfile(values);

    formikHelpers.resetForm({
      values: generateUserProfileToInitialValues(
        newEntity ?? {
          first_name: "",
          last_name: "",
        }
      ),
    });
    queryClient.setQueryData(queryKey, newEntity);

    //  setEditProfileDrawerAction(true);
    closeAllDrawerAction();
  };

  const onEditUserProfile = useFormSubmit(...formSubmitToEditUserProfile());

  return (
    <Drawer
      title={t("users.actions.update.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeAllDrawerAction}
      open={isEditProfileDrawerOpen}
      bodyStyle={{ padding: 10 }}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        // validationSchema={{}}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayEditUserForm EditFlag={true} />
        </DirtyFormPrompt>
      </Formik>
    </Drawer>
  );
};
